import { Button, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { BasicDialog } from 'components';

const ConfirmModalDefectChecked = ({ open, onClose, handleDialogAction }) => {
  return (
    <BasicDialog
      title="Attenzione"
      open={open}
      onClose={onClose}
      actions={
        <>
          <Button onClick={onClose}>Annulla</Button>
          <Button variant="contained" onClick={() => handleDialogAction()}>
            Conferma
          </Button>
        </>
      }
    >
      <Typography>
        {
          'Proseguendo, tutti i difetti di questa scheda saranno marcati come Visto e NP'
        }
      </Typography>
    </BasicDialog>
  );
};

ConfirmModalDefectChecked.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  handleDialogAction: PropTypes.func,
};

export { ConfirmModalDefectChecked };
